import { render, staticRenderFns } from "./RedirectNect.vue?vue&type=template&id=ea15b24a&"
import script from "./RedirectNect.vue?vue&type=script&lang=js&"
export * from "./RedirectNect.vue?vue&type=script&lang=js&"
import style0 from "./RedirectNect.vue?vue&type=style&index=0&id=ea15b24a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports